import { useTranslation } from "../context/LanguageContext";

export default function PossiblePennyBadge() {
  const { t } = useTranslation();
  return (
    <span
      className="inline-flex rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-800 dark:bg-amber-900/40 dark:text-amber-200"
      title={t("products.possiblePennyDescription")}
    >
      {t("products.possiblePenny")}
    </span>
  );
}
